<template>
  <div class="container">
    <div class="ios_content">
      <div v-if="!pcWX" class="arrow">
        <img src="@/assets/images/arrow.png" />
      </div>
      <h1 v-if="!pcWX" style="margin-top: 65px">请您点一下此按钮</h1>
      <h1 v-if="!pcWX" style="margin-bottom: 16px;">{{ ios ? '选择"在safari中打开"': '选择"在浏览器中打开"' }}</h1>
      <div v-else class="pc-weixin">
        <h1 style="margin-top: 36px;">{{ '如需浏览，请复制网址后使用浏览器访问' }}</h1>
        <p>{{ url }}</p>
      </div>
      <div v-if="!pcWX" class="ios">
        <img v-if="ios" src="@/assets/images/ios.png" />
        <img v-else src="@/assets/images/android.png" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'OpenTips',
  computed: {
    ...mapState(['environment']),
    ios() {
      const { iPad, iPhone } = this.environment
      return iPad || iPhone
    },
    pcWX() {
      const { android, iPad, iPhone, weixin, mqqbrw } = this.environment
      return ((!android && !iPad && !iPhone) && weixin) || mqqbrw
    },
    url() {
      return window.location.href
    }
  }
}
</script>
<style lang="stylus" scoped>
  img {
    width: 100%;
    height: auto;
  }
  .arrow {
    width: 48px;
    height: 52px;
    position: absolute;
    right: 27px;
    top: 10px;
  }
  .ios {
    margin-top: 10px;
    display: inline-block;
    width: 96%;
    height: auto;
  }
  .container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
  }
  .ios_content {
    max-width: 450px;
    min-width: 300px;
    margin: 0 auto;
    overflow: hidden;
    padding: 0 20px;
    text-align: center;
    position: relative;
    border: 1px solid transparent;
    display: block;
    .pc-weixin {
      p {
        color: #000;
        margin-top: 15px;
      }
    }
  }
  .ios_content h1 {
    color: #f5751c;
    font-size: 28px;
    line-height: 1.6;
    letter-spacing: 2px;
    font-weight: bold;
  }
  @media only screen and (max-width: 320px) {
    .ios {
      width: 200px;
      height: 230px;
    }
    .ios_content h1 {
      font-size: 20px;
    }
  }
</style>
